import { withLogger } from '../../utils/withLogger';
import { IS_DEV } from '../../environment';
import ReactDOM from 'react-dom';
import rehydrate, { IRehydratedNode } from '@tr-digital/react-rehydrate';
import rehydrators from '../../rehydrate/rehydrators';

let renderRehydratableAsPortal = ({ root, rehydrated }: IRehydratedNode) => {
  const portal = ReactDOM.createPortal(rehydrated, root);

  // we have to clear out the container's markup
  // when the portal is rendered into the dom it is appended to its container
  root.innerHTML = '';

  return Promise.resolve(portal);
};

if (IS_DEV) {
  renderRehydratableAsPortal = withLogger('PortalRehydrator', ({ root }) => {
    const dataSelector = 'data-rehydratable';
    const nodeList = root.cloneNode(true).querySelectorAll(`[${dataSelector}]`);

    if (nodeList.length) {
      return [nodeList[0].getAttribute(dataSelector), nodeList[0]];
    }

    return null;
  })(renderRehydratableAsPortal);
}

const rehydrateToPortals = () => {
  // @ts-ignore
  return rehydrate(document.body, rehydrators, renderRehydratableAsPortal);
};

export default rehydrateToPortals;
export { rehydrateToPortals };
